"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverClientAddressUnit = void 0;
const fdr_lib_ssp_ssp_unit_1 = require("@hotelplan/fdr.lib.ssp.ssp-unit");
const client_address_utils_1 = require("./client-address.utils");
exports.serverClientAddressUnit = fdr_lib_ssp_ssp_unit_1.ServerSideUnit.createServerSideUnit(null, (ctx) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    return {
        props: {
            [client_address_utils_1.CLIENT_ADDRESS_PROP]: {
                clientAddress: ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b['x-real-ip']) ||
                    ((_d = (_c = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _c === void 0 ? void 0 : _c.socket) === null || _d === void 0 ? void 0 : _d.remoteAddress) ||
                    '',
            },
        },
    };
}), new fdr_lib_ssp_ssp_unit_1.ServerSideUnitRef(`client-address`));
//# sourceMappingURL=serverClientAddressUnit.js.map